/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The file's status.
 */
export const FileStatus = {
  Pending: "pending",
  Approved: "approved",
  Rejected: "rejected",
} as const;
/**
 * The file's status.
 */
export type FileStatus = ClosedEnum<typeof FileStatus>;

/** @internal */
export const FileStatus$inboundSchema: z.ZodNativeEnum<typeof FileStatus> = z
  .nativeEnum(FileStatus);
/** @internal */
export const FileStatus$outboundSchema: z.ZodNativeEnum<typeof FileStatus> =
  FileStatus$inboundSchema;
